import { DataGrid } from "@mui/x-data-grid";
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import AppBreadcrumbs from "../../components/AppBreadcrumbs";
import * as services from "./../../services/saleng";
import { useState, useEffect } from "react";
import dayjs from "dayjs";
import "dayjs/locale/th";
import localizedFormat from "dayjs/plugin/localizedFormat";
import VisibilityIcon from "@mui/icons-material/Visibility";

dayjs.extend(localizedFormat);
dayjs.locale("th");

export default function TransformTransactionsTemplate() {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [search, setSearch] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    async function fetchData() {
      setLoading(true);
      setError(null);
      try {
        const res = await services.getTransformTransaction();
        const transformTransaction = res.data.data;
        console.log("transformTransaction ", transformTransaction);
        setTransactions(transformTransaction || []);
      } catch (err) {
        setError(err.message || "Unknown error");
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, []);

  // แปลง transactions เป็น rows สำหรับ DataGrid
  const rows = transactions.map((t, index) => ({
    id: index,
    transaction_id: t.id,
    date: dayjs(t.createdAt).add(543, "year").format("DD MMM YYYY เวลา HH:mm"),
    origin: t.origin.title,
    origin_weight: t.originWeight,
    destination: t.destination.title,
    destination_weight: t.destinationWeight,
    transformed_by: `${t.transformer.name} ${t.transformer.lastname}`,
  }));

  // กำหนด columns สำหรับ DataGrid
  const columns = [
    { field: "date", headerName: "ณ วันที่", flex: 2 },
    { field: "origin", headerName: "ต้นทาง", flex: 1.5 },
    { field: "origin_weight", headerName: "น้ำหนัก", flex: 1.5 },
    { field: "destination", headerName: "ปลายทาง", flex: 1.5 },
    { field: "destination_weight", headerName: "น้ำหนัก", flex: 1.5 },
    { field: "transformed_by", headerName: "แปรสภาพโดย", flex: 1 },
    {
      field: "detail",
      headerName: "รายละเอียด",
      width: 120,
      sortable: false,
      renderCell: (params) => (
        <button
          type="button"
          onClick={() =>
            navigate(`exchange?view=${params.row.transaction_id}`)
          }
          className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-slate-100 text-slate-700 hover:bg-blue-50 hover:text-blue-700 font-bold text-xs transition-colors"
        >
          <VisibilityIcon sx={{ fontSize: 18 }} />
          ดู
        </button>
      ),
    },
  ];

  if (loading) return <div className="p-6 text-slate-500">กำลังโหลดข้อมูล...</div>;
  if (error) return <div className="p-6 text-red-500">เกิดข้อผิดพลาด: {error}</div>;

  return (
    <div className="min-h-screen bg-slate-50 p-6">
      <AppBreadcrumbs />

      <div className="mt-6 mb-6 flex flex-col sm:flex-row items-stretch sm:items-center justify-between gap-4">
        {/* Search */}
        <div className="w-full sm:max-w-md">
            <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <SearchIcon className="text-slate-400" />
                </div>
                <input
                    type="text"
                    className="block w-full pl-10 pr-3 py-3 border border-gray-200 rounded-xl leading-5 bg-white placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-blue-100 focus:border-blue-400 sm:text-sm transition duration-150 ease-in-out shadow-sm"
                    placeholder="ค้นหารายละเอียด..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value.trimStart())}
                />
            </div>
        </div>

         {/* Action Button */}
        <button
            onClick={() => navigate("exchange")}
            className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-bold rounded-xl text-white bg-blue-600 hover:bg-blue-700 active:scale-95 transition-all shadow-md shadow-blue-100 gap-2"
        >
            <AddIcon />
            เริ่มแปรสภาพ
        </button>
      </div>

      {/* DataGrid Container */}
      <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
        <div style={{ height: 600, width: "100%" }}>
          <DataGrid
            rows={rows.filter(
              (row) =>
                row.origin.toLowerCase().includes(search.toLowerCase()) ||
                row.destination.toLowerCase().includes(search.toLowerCase()) ||
                row.transformed_by.toLowerCase().includes(search.toLowerCase())
            )}
            columns={columns}
            loading={loading}
            disableRowSelectionOnClick
            localeText={{
              noRowsLabel: "ไม่พบข้อมูล",
            }}
            sx={{
                border: 'none',
                '& .MuiDataGrid-columnHeaders': {
                    backgroundColor: '#f8fafc',
                    color: '#475569',
                    fontWeight: 'bold',
                },
                '& .MuiDataGrid-cell': {
                    borderBottom: '1px solid #f1f5f9',
                    color: '#334155',
                },
                 '& .MuiDataGrid-row:hover': {
                    backgroundColor: '#f8fafc',
                },
            }}
          />
        </div>
      </div>
    </div>
  );
}
